import { createSelector } from 'reselect';
import { BrandListerGroupedFilterTypes } from '@as-react/common-types';
const getBrandListerState = state => state.brandLister;
export const makeGetBrandListerItems = () => createSelector(getBrandListerState, (brandLister) => {
    const activeFilter = brandLister.filters.find(item => item.active);
    const mappedItems = {};
    const addToMappedItems = (item) => {
        const startChar = item.description.charAt(0).toUpperCase();
        if (!mappedItems[startChar]) {
            mappedItems[startChar] = [];
        }
        mappedItems[startChar].push(item);
    };
    if (!activeFilter) {
        return mappedItems;
    }
    switch (activeFilter.key) {
        case BrandListerGroupedFilterTypes.ALL: {
            brandLister.items.forEach(addToMappedItems);
            break;
        }
        case BrandListerGroupedFilterTypes.POPULAR: {
            mappedItems[BrandListerGroupedFilterTypes.POPULAR] = brandLister.items
                .filter((item) => Object.hasOwn(brandLister.popularList, item.id))
                .sort((a, b) => {
                const compareA = brandLister.popularList[a.id].toString();
                const compareB = brandLister.popularList[b.id].toString();
                return compareA.localeCompare(compareB, undefined, {
                    sensitivity: 'base',
                    numeric: true,
                });
            })
                .reverse();
            break;
        }
        case BrandListerGroupedFilterTypes.NUMBERS: {
            brandLister.items.filter(item => item.description.charAt(0).match(/([0-9])/g)).forEach(addToMappedItems);
            break;
        }
        default: {
            brandLister.items
                .filter(item => item.description.charAt(0).toUpperCase() === activeFilter.key)
                .forEach(addToMappedItems);
            break;
        }
    }
    return mappedItems;
});
export const makeGetBrandListerFilters = () => createSelector(getBrandListerState, (brandLister) => {
    return brandLister.filters;
});
